import { useCallback, useState } from "react";

export const useConfirmationPageChangeDialog = () => {
  const [showConfirmPageChangeDialog, setShowConfirmPageChangeDialog] =
    useState(false);
  const [resolver, setResolver] = useState<
    ((value: "confirm" | "cancel") => void) | null
  >(null);

  const awaitUserDecision = useCallback((): Promise<"confirm" | "cancel"> => {
    setShowConfirmPageChangeDialog(true);

    return new Promise<"confirm" | "cancel">((resolve) => {
      setResolver(() => resolve);
    });
  }, []);

  const handleConfirmPageChange = useCallback(() => {
    setShowConfirmPageChangeDialog(false);
    resolver?.("confirm");
    setResolver(null);
  }, [resolver]);

  const handleCancelPageChange = useCallback(() => {
    setShowConfirmPageChangeDialog(false);
    resolver?.("cancel");
    setResolver(null);
  }, [resolver]);

  return {
    showConfirmPageChangeDialog,
    handleConfirmPageChange,
    handleCancelPageChange,
    setShowConfirmPageChangeDialog,
    awaitUserDecision,
  };
};
